import type {SavedView} from './types'

export const VIEWS_SORT_OPTIONS = [
  {label: 'Recently Updated', value: 'recently_updated'},
  {label: 'Newest', value: 'newest'},
  {label: 'Oldest', value: 'oldest'},
  {label: 'Least Recently Updated', value: 'least_recently_updated'},
  {label: 'Name', value: 'name'},
] as const

export type ViewsSortOption = (typeof VIEWS_SORT_OPTIONS)[number]
export type ViewsSortValue = ViewsSortOption['value']

const DEFAULT_VIEWS_SORT_OPTION: ViewsSortOption = VIEWS_SORT_OPTIONS[0]
export const DEFAULT_VIEWS_SORT: ViewsSortValue = DEFAULT_VIEWS_SORT_OPTION.value

export function isViewsSortValue(value: string | null | undefined): value is ViewsSortValue {
  return VIEWS_SORT_OPTIONS.some(option => option.value === value)
}

export function getViewsSortOption(value: ViewsSortValue): ViewsSortOption {
  return VIEWS_SORT_OPTIONS.find(option => option.value === value) ?? DEFAULT_VIEWS_SORT_OPTION
}

export function sortViews(views: readonly SavedView[], sort: ViewsSortValue): SavedView[] {
  const copy = [...views]
  switch (sort) {
    case 'newest':
      return copy.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    case 'oldest':
      return copy.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt))
    case 'least_recently_updated':
      return copy.sort((a, b) => Date.parse(a.updatedAt) - Date.parse(b.updatedAt))
    case 'name':
      return copy.sort((a, b) => a.name.localeCompare(b.name))
    case 'recently_updated':
    default:
      return copy.sort((a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt))
  }
}
